import { useEffect } from 'react';
import { getAuth } from 'firebase/auth';

const DebugClaims = () => {
  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        const tokenResult = await user.getIdTokenResult();
        console.log("DEBUG: User token claims:", tokenResult.claims);
      } else {
        console.log("DEBUG: No user is signed in.");
      }
    });

    return () => unsubscribe();
  }, []);

  return null;
};

export default DebugClaims;